
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications.listItem.actions';

export default defineMessages({
  checkReport: {
    id: `${scope}.checkReport`,
    defaultMessage: 'Check for errors',
  },
  generateURNs: {
    id: `${scope}.generateURNs`,
    defaultMessage: 'Generate URNs',
  },
  generatingURNsFile : {
    id: `${scope}.generatingURNsFile`,
    defaultMessage: 'Generating URNs File',
  },
  downloadedURNS: {
    id: `${scope}.downloadedURNs`,
    defaultMessage: 'Downloaded URNs ',
  },
  errorDownloadingURNS: {
    id: `${scope}.errorDownloadingURNs`,
    defaultMessage: 'Error downloading URNs ',
  },
  errorDownloadingURNSNotOwner: {
    id: `${scope}.errorDownloadingURNsNotOwner`,
    defaultMessage: 'You are not the owner.',
  },
  outputInfo: {
    id: `${scope}.outputInfo`,
    defaultMessage: 'Output info',
  },
  reportFailed: {
    id: `${scope}.reportFailed`,
    defaultMessage: 'Report generation failed.',
  },
  reportDownloaded: {
    id: `${scope}.reportDownloaded`,
    defaultMessage: 'Report downloaded.',
  },
  generatingReport: {
    id: `${scope}.reportFailed`,
    defaultMessage: 'Generating report : ',
  },
  generatePreSignedURL: {
    id: `${scope}.generatePreSignedURL`,
    defaultMessage: 'Generate pre-signed URL',
  },
  copyPreSignedURLToClipboard: {
    id: `${scope}.copyPreSignedToClipboard`,
    defaultMessage: 'Copy to clipboard: Ctrl+C or ⌘+C, Enter',
  },
  versionChanges: {
    id: `${scope}.versionChanges`,
    defaultMessage: 'Version Changes',
  },
  downloadSBMediaGrid: {
    id: `${scope}.downloadSBMediaGrid`,
    defaultMessage: 'Download SB Media Grid',
  },
  sbMediaGridDownloadFail: {
    id: `${scope}.sbMediaGridDownloadFail`,
    defaultMessage: 'No SB Media Grid available for this deployment. Confirm your course has scoreable learning tools within, then try again.', 
  },
  internalServerErrorMessage: {
    id: `{$.scope}.internalServerErrorMessage`,
    defaultMessage: 'Failed to download, please try again',
  },
  invalidSBMediaGridOption: {
    id: `${scope}.invalidSBMediaGridOption`,
    defaultMessage: 'SB Media Grid is not a valid option for this course type',
  },
  noPublicationHistory: {
    id: `${scope}.noPublicationHistory`,
    defaultMessage: 'No publication history available',
  },
});
